<template>
    <div class="step-choose-a-theme-wrapper">
        <div class="mb-5 font-semibold text-3xl text-uppercase">Gestalte jetzt dein personalisiertes Stimmenporträt!</div>
        <div class="mb-5 choose-a-theme-description">Wähle zuerst dein Thema: Classic (eine Person), Love (zwei Personen) oder Family (fünf Personen). Unser Konfigurator führt dich im Anschluss einfach durch jeden Gestaltungsschritt.</div>
        <vueper-slides
            :lazy="false"
            :arrows="true"
            arrows-outside
            :bullets="false"
            :infinite="false"
            :touchable="false"
            prevent-y-scroll
            ref="themeSlider"
            class="no-shadow"
            fixed-height="100%"
            :visible-slides="3"
            :dragging-distance="70"
            :breakpoints="{
                600: { visibleSlides: 1, slideMultiple: 1 },
                900: { visibleSlides: 2, slideMultiple: 1 }
            }">
            <template #arrow-left>
                <svg viewBox="0 0 9 18"><path stroke-linecap="round" d="m8 1 l-7 8 7 8"></path></svg>
            </template>
            <template #arrow-right>
                <svg viewBox="0 0 9 18"><path stroke-linecap="round" d="m1 1 l7 8 -7 8"></path></svg>
            </template>
            <vueper-slide v-for="(theme, idx) in themes" :key="idx" class="theme-container">
                <template #content>
                    <Theme :title="theme.title"
                        class="mb-4"
                        :desc="theme.desc"
                        @select="selectTheme(theme)"
                        :price="(basePrice + theme.price)"
                        :maxRecordings="theme.maxRecordings"
                    ></Theme>
                </template>
            </vueper-slide>
        </vueper-slides>
    </div>
</template>

<script type="text/javascript">
import Theme from './Theme.vue';
import { mapFields } from 'vuex-map-fields';
import defaults from '~/scripts/Pipeline/_defaults.js';
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css';

export default {
    components: {
        Theme,
        VueperSlides,
        VueperSlide,
    },
    computed: {
        ...mapFields({
            'basePrice': 'basePrice',
            'themes': 'availableThemes'
        })
    },
    data() {
        return {
            justDragged: false
        }
    },
    mounted() {
        // this.$refs.themeSlider.$el.addEventListener('click', (event) => {
        //     this.justDragged = this.$refs.themeSlider.justDragged();
        // });
    },
    methods: {
        selectTheme(theme) {
            // wait until slider click event has been processed to distinguish drag action and intentional selection
            // setTimeout(() => {
            //     if (!this.justDragged) {
                    this.$store.commit('updateField', {
                        path: 'theme',
                        value: theme
                    });

                    this.$store.commit('updateField', {
                        path: `stageConfiguration.borderColor2`,
                        value: theme.title == 'Love' ? defaults.waveConfiguration.backgroundColor : null
                    });

                    this.$store.commit('updateField', {
                        path: 'step',
                        value: 1
                    });
            //     }
            // }, 50);
        }
    }
};
</script>
